import React from 'react';
import {
  HomefieldIconSocialFacebook,
  HomefieldIconSocialInstagram,
  HomefieldIconSocialX,
  HomefieldIconSocialYoutube,
} from '@dsg-tech/homefield-react-icons';
import './FooterSocialLinks.scss';

export default function FooterSocialLinks() {
  return (
    <div
      data-testid="footer-social-links"
      className="footerSocialLinks-container hmf-py-xl hmf-py-m-0">
      <a
        href="https://www.facebook.com/publiclandsshop"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on facebook"
        rel="noreferrer">
        <HomefieldIconSocialFacebook className="hmf-pr-s" />
      </a>
      <a
        href="https://www.instagram.com/publiclandsshop"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on instagram"
        rel="noreferrer">
        <HomefieldIconSocialInstagram className="hmf-pr-s" />
      </a>
      <a
        href="https://www.twitter.com/publiclandsshop"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on X"
        rel="noreferrer">
        <HomefieldIconSocialX className="hmf-pr-s" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCq0I2s_omAmGJkis8CAFA4w"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on youtube"
        rel="noreferrer">
        <HomefieldIconSocialYoutube />
      </a>
      <p className="footerSocialLinks-container__text hmf-body-l">
        <span>Follow us.</span> We’ll guide you.
      </p>
    </div>
  );
}
